import Link from "next/link";

import type { SiteLocale } from "@/lib/graphql";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";

export function ResponsiveBanner(props: {
  record: FragmentOf<typeof fragment.ResponsiveBannerFragment>;
  locale: SiteLocale;
}) {
  const record = readFragment(fragment.ResponsiveBannerFragment, props.record);

  if (!record.banner) {
    return null;
  }

  return (
    <div className="container mx-auto my-10 max-w-[780px] px-4 lg:px-0">
      {record.banner.map((ban) => (
        <Link
          key={ban.id}
          href={`${ban?.url || "/"}`}
          className="group relative block overflow-hidden"
        >
          {/* Dark overlay */}
          <div className="absolute inset-0 z-10 bg-black/30 transition-opacity duration-300 group-hover:opacity-0" />

          {/* Centered button - hidden by default, shown on hover */}
          <div className="absolute inset-0 z-20 flex items-center justify-center uppercase transition-opacity duration-300 group-hover:opacity-100 lg:opacity-0">
            <div className="bg-eurac-red scale-95 transform rounded-full px-6 py-3 tracking-[0.85px] text-white shadow-lg transition-transform duration-300 group-hover:scale-100">
              Get Directions
            </div>
          </div>

          <picture>
            {ban?.desktopBanner?.url && (
              <source media="(min-width: 1024px)" srcSet={`${ban?.desktopBanner?.url}`} />
            )}
            {ban?.mobileBanner?.url && (
              <source media="(max-width: 1023px)" srcSet={`${ban?.mobileBanner?.url}`} />
            )}
            <img
              src={`${ban?.desktopBanner?.url}`}
              alt="banner"
              className="h-auto w-full transition-transform duration-300 group-hover:scale-105"
            />
          </picture>
        </Link>
      ))}
    </div>
  );
}
